import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';

/**
 * FooterColumn is a layout primitive for grouping footer items in a row.
 *
 * Why this exists:
 * - Keeps alignment, spacing, and wrapping rules centralized for footer content.
 * - Lets Footer composition focus on content instead of low-level layout details.
 *
 * Use this when:
 * - You are composing left/center/right content inside FooterRow.
 * - You need a consistent row of FooterItem blocks with optional wrapping.
 *
 * Typical usage:
 * <FooterColumn wrap gap=".5rem .75rem">...</FooterColumn>
 */
function FooterColumn({
	children,
	alignItems = 'center',
	justifyContent = 'flex-start',
	wrap = false,
	gap = '.5rem',
	sx = undefined,
}) {
	return (
		<Stack
			direction="row"
			alignItems={alignItems}
			justifyContent={justifyContent}
			flexWrap={wrap ? 'wrap' : 'nowrap'}
			gap={gap}
			sx={sx}
		>
			{children}
		</Stack>
	);
}

FooterColumn.propTypes = {
	children: PropTypes.node,
	alignItems: PropTypes.string,
	justifyContent: PropTypes.string,
	wrap: PropTypes.bool,
	gap: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	sx: PropTypes.object,
};

export default FooterColumn;
